/**
 * Centralised storage key constants for the CastOffPro app.
 *
 * The app was previously branded `vf`; all keys are being migrated to the
 * `castoffpro.` namespace. `migrate-vf-to-castoffpro.ts` performs a one-shot copy
 * from the legacy keys on startup. Every module that reads or writes a
 * persisted setting MUST import from here instead of hard-coding strings,
 * so the migration list stays the single source of truth.
 */

/** localStorage keys (durable across browser sessions). */
export const CASTOFFPRO_PLAYER_BOAT_ID = "castoffpro.playerBoatId";
export const CASTOFFPRO_TERRAIN_ID = "castoffpro.terrainId";
export const CASTOFFPRO_RENDER_QUALITY = "castoffpro.renderQuality";
export const CASTOFFPRO_AUDIO_MUTED = "castoffpro.audio.muted.v2";
export const CASTOFFPRO_AUDIO_VOLUME = "castoffpro.audio.volume.v2";
export const CASTOFFPRO_LOCALE = "castoffpro.locale.v1";

/** Gamification keys (Practice MVP + planned Career). */
export const CASTOFFPRO_GAMIFICATION_PRACTICE = "castoffpro.gamification.practice.v1";
export const CASTOFFPRO_GAMIFICATION_PROFILE = "castoffpro.gamification.profile.v1";
export const CASTOFFPRO_GAMIFICATION_CAREER = "castoffpro.gamification.career.v1";

/** sessionStorage keys (cleared when the tab closes). */
export const CASTOFFPRO_PENDING_NEW_GAME_STATE = "castoffpro.pendingNewGameState.v1";
export const CASTOFFPRO_SETUP_PREVIEW = "castoffpro.setupPreview.v1";

/**
 * Migration mapping: legacy `vf.*` key → current `castoffpro.*` key, separated
 * by storage scope. The migrator iterates these tables on app startup and
 * is the only place either side needs to know about the legacy names.
 */
export const LEGACY_LOCAL_STORAGE_MIGRATIONS: ReadonlyArray<
  readonly [string, string]
> = [
  ["vf.playerBoatId", CASTOFFPRO_PLAYER_BOAT_ID],
  ["vf.terrainId", CASTOFFPRO_TERRAIN_ID],
  ["vf.renderQuality", CASTOFFPRO_RENDER_QUALITY],
  ["vf.audio.muted.v2", CASTOFFPRO_AUDIO_MUTED],
  ["vf.audio.volume.v2", CASTOFFPRO_AUDIO_VOLUME],
];

export const LEGACY_SESSION_STORAGE_MIGRATIONS: ReadonlyArray<
  readonly [string, string]
> = [
  ["vf.pendingNewGameState.v1", CASTOFFPRO_PENDING_NEW_GAME_STATE],
  ["vf.setupPreview.v1", CASTOFFPRO_SETUP_PREVIEW],
];
